import styled from 'styled-components'

export const Wrapper = styled.div<{ isSelected: boolean }>`
  margin-bottom: 1.5rem;
  z-index: ${p => p.isSelected && 1};
`

export const Menu = styled.div`
  position: absolute;
  top: 58px;
  min-width: 330px;
  left: 0;
  right: 0;
  outline: 0;
  background-color: #f7f9fc;
  border-radius: 4px;
  /* margin-top: 8px; */
  z-index: 2;
  padding: 20px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.25);
`
export const MainButton = styled.button<{ isSelected: boolean }>`
  cursor: pointer;
  font-size: 1rem;
  color: #152735;
  line-height: 1.5rem;
  height: 50px;
  text-align: left;
  border: 1px solid #e3e7ed;
  background-color: #f7f9fc;
  border-radius: 4px;
  margin: 0;
  padding: 0.75rem 2.5rem 0.75rem 0.75rem;
  text-decoration: none;
  width: 100%;
  border-color: ${p => p.isSelected && '#585D64'};
  outline: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`
export const StyledDropdown = styled.div`
  position: relative;
  width: 100%;
`
export const StyledIndicator = styled.div`
  color: gray;
  height: 24;
  width: 32;
  display: ${props => (props.hidden ? 'inline-block' : 'none')};
`
export const ArrowBlock = styled.div`
  position: absolute;
  margin-right: -6px;
  right: 10px;
  top: 20px;
  margin-top: auto;
  margin-bottom: auto;
`
export const TooltipWrap = styled.div`
  margin-left: auto;
`
export const LabelWrap = styled.div`
  display: flex;
  align-content: space-between;
  width: 100%;
`
